<template>
 <div 
    class="loader" 
    :class="{ 'loader--visible': loading }"
 >
  <circle-8 class="loader-element"></circle-8>
  </div>
</template>
<script>
import { Circle8 } from 'vue-loading-spinner';
import { mapState } from "vuex";
export default {
  name: "Loader",
  props: ["visible"],
  components: {
    Circle8
  },
  computed: {
    ...mapState("loader", ["loading"])
  }
};
</script>
<style lang="scss">
.loader {
  z-index: 9999;
  //background: rgba(255, 255, 255, 0.8);
  background-color: rgba(243,243,243,0.4); /* Black background with opacity */
  transition: 0.15s ease-in opacity;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 0;
  &--visible {
    opacity: 1;
    pointer-events: all;
  }
}
.loader-element{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>